import apiClient from "./axiosConfig"

const url = 'users/profile/document-verifications/'

const getDocumentVerifications = async() => await apiClient.get(url)

export default {
    getDocumentVerifications
}